import React, { FC } from "react";
import { Col, Row } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import "../recommendations/recommendations.scss";
import PinUnpin from "@pages/member-details/pin-unpin-component";
import CustomTooltip from "@pages/tool-tip";

const GapMedication: FC<any> = (props) => {
  const genExtra = (id:any) => <PinUnpin marginRight={"0px"} dataCardId={id} changeHandler={props?.pinChangeHandler}
  pinCardIds={props.pinCardIds}/>;
  const getHeading = (headerValue: any) => (
    <>
      <span>{headerValue}</span>
      <CustomTooltip
        toolTipvalue={headerValue}
        children={
          <span
            style={{margin: "7px 8px" }}
            className="icon icon-info clr-lightGrayColor"
          ></span>
        }
      />
    </>
  );
  
  return (
    <>
      <Row className="title">
        <Col span={22}>{getHeading("Gaps In Medication")}</Col>
        <Col>
          {/* <span style={{ marginRight: "0px" }}>
            <img src={PushPin} alt="push-pin" />
          </span> */}
          {genExtra(props?.data?.datacardId)}
        </Col>
      </Row>

      {props?.data?.values?.length>0 && <Row>
        <Col span={16}></Col>
        <Col span={4}>
          <span className="f12 clr-lightGrayColor recommendations-status">
            {" "}
            On Going
          </span>
        </Col>
        <Col span={4}>
          <span className="f12 clr-lightGrayColor recommendations-status">
            {" "}
            Completed
          </span>
        </Col>
      </Row>}
      {props?.data?.values?.map((medication:any, idx:number) => {
        let ongoingColor =
          medication.insightStatus === "Ongoing" ? "#f2960d" : "#dfe1e6";
        let completedColor =
          medication.insightStatus === "Completed" ? "#1bbe75" : "#dfe1e6";

        return (
          <Row>
            <Col span={16}>
              <span className="medication-title f16">
                {idx+1}. {medication.insightDesc}
              </span>
            </Col>
            <Col span={4}>
              <CheckCircleOutlined
                className="recommendations-status"
                style={{ color: ongoingColor }}
              />
            </Col>
            <Col span={4}>
              <CheckCircleOutlined
                className="recommendations-status"
                style={{ color: completedColor }}
              />
            </Col>
          </Row>
        );
      })}
    </>
  );
};

export default GapMedication;
